import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      userSelect: "none",
      cursor: "pointer",
    },
    text: {
      marginTop: 1,
      marginLeft: spacing.xxxs,
      color: theme.chart.projection.default.text,
      fontSize: 12,
    },
  };

  return styles;
};
